{
  "name": "sqeptech-connect-gui",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng dev --configuration local",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "i18n:extract": "transloco-keys-manager extract",
    "i18n:find": "transloco-keys-manager find",
    "lint": "ng lint"
  },
  "type": "module",
  "private": true,
  "dependencies": {
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@angular/animations": "19.2.1",
    "@angular/cdk": "19.2.1",
    "@angular/common": "19.2.1",
    "@angular/core": "19.2.1",
    "@angular/forms": "19.2.1",
    "@angular/localize": "19.2.1",
    "@angular/material": "19.2.1",
    "@angular/material-date-fns-adapter": "19.2.1",
    "@angular/platform-browser": "19.2.1",
    "@angular/platform-browser-dynamic": "19.2.1",
    "@angular/router": "19.2.1",
    "@azure/msal-angular": "^4.0.2",
    "@azure/msal-browser": "^4.0.2",
    "@okta/okta-angular": "^6.4.0",
    "@okta/okta-auth-js": "^7.10.1",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@ng-idle/core": "^16.0.0",
    "@ng-idle/keepalive": "^16.0.0",
    "@ng-select/ng-option-highlight": "^14.2.0",
    "@ng-select/ng-select": "^14.2.0",
    "@jsverse/transloco": "^7.5.1",
    "rxjs": "~7.8.1",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0",
    "bootstrap": "^5.3.3",
    "core-js": "^3.40.0",
    "date-fns": "^3.6.0",
    "cron-parser": "^5.4.0"
  },
  "devDependencies": {
    "@analogjs/platform": "^1.13.1",
    "@analogjs/vite-plugin-angular": "^1.13.0",
    "@analogjs/vitest-angular": "^1.13.1",
    "@angular/build": "19.2.1",
    "@angular/cli": "19.2.1",
    "@angular/compiler": "19.2.1",
    "@angular/compiler-cli": "19.2.1",
    "@jsverse/transloco-keys-manager": "^6.1.0",
    "@types/jasmine": "~5.1.5",
    "@types/bootstrap": "^5.2.10",
    "angular-eslint": "19.2.1",
    "eslint": "^9.21.0",
    "eslint-import-resolver-typescript": "^3.8.3",
    "eslint-plugin-boundaries": "^5.0.1",
    "jasmine-core": "~5.5.0",
    "typescript": "~5.8.2",
    "typescript-eslint": "^8.26.0",
    "vitest": "^3.2.4",
    "vite": "^6.0.11",
    "vite-tsconfig-paths": "^5.1.4",
    "@nx/vite": "^20.4.6",
    "@vitest/coverage-v8": "^3.0.5",
    "patch-package": "^8.0.0"
  },
  "overrides": {
    "@nx/vite": {
      "vite": "$vite",
      "vitest": "$vitest"
    }
  },
  "volta": {
    "node": "20.18.2"
  }
}
